import { animation } from './animation.js';

/**
 * アコーディオン機能
 * @param {string} eventClass - アコーディオントリガーのクラス名
 */
export function accordion(eventClass) {
  const eventElms = document.getElementsByClassName(eventClass);
  if (!eventElms.length) return;

  for (let i = 0; i < eventElms.length; i++) {
    const target = eventElms[i];
    const targetId = target.dataset.target;
    let next;

    if (targetId) {
      next = document.getElementById(targetId);
      next.style.height = next.clientHeight + 'px';
      next.classList.add('is-close');
    } else {
      next = target.nextElementSibling;
      next.style.height = next.clientHeight + 'px';
      next.classList.add('is-close');
    }

    target.addEventListener('click', function () {
      target.classList.toggle('is-active');
      next.classList.toggle('is-close');
      setTimeout(function () {
        animation('anime');
      }, 500);
    });
  }

  setTimeout(function () {
    const qaTarget = document.getElementsByClassName('qa')[0];
    if (qaTarget) {
      qaTarget.classList.add('is-loaded');
    }
  }, 500);
}
